import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import GustoAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/GustoAppIcon';

import GustoButton from '../OtherComponents/GustoButton';

const GustoStrategy = {
  previewInfo: {
    name: 'Gusto',
    newTab: true,
    iconSvg: <GustoAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Gusto',
    category: 'Payroll, benefits, and HR built for small business',
    details:
      'Old-school payroll and HR aren’t built for the way you work today. But Gusto is. Gusto makes payroll, benefits, and HR actually easy. ' +
      'Plus, it gives you access to certified experts to help you protect the business you are building and the benefits you need to take care of your team. ' +
      'That’s the reason more than 100,000 small businesses nationwide choose Gusto. ',
    iconSvg: <GustoAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/z4ydo9kx8y',
  },
  sellingPoints: {
    headline: '',
    bottomDescription: (
      <>
        <Typography variant="subtitle2">Why Gusto?</Typography>
        <p>
          85% of customers say Gusto is easier to use than their previous payroll provider. 3 out of 4 customers say
          Gusto makes compliance easier. Gusto is a PCMag Editors’ Choice winner and the top ranked provider in their
          list of best online payroll software of 2018. You can manage your payroll, benefits, 401(k), workers’ comp,
          and HR all in one place – and keep them all in sync. Gusto integrates with accounting, time-tracking, and
          expense software to keep your business in sync.
        </p>

        <Typography variant="subtitle2">What you get with Gusto:</Typography>
        <p>
          Gusto automatically calculates, pays, and files your federal, state and local payroll taxes, as well as W-2s,
          1099s, and new hire forms. Unlimited payrolls, all 50 states, and direct deposit come standard. Stellar
          support and expert advice are here when you need it—by phone, email, or chat. New employees self-onboard
          entirely online, reducing errors and paperwork. Employees get fun payday emails, lifetime accounts, direct
          deposit, and more.
        </p>

        <Typography variant="subtitle2">
          Want to learn more about how this integration works? Visit our help center:
        </Typography>
        <p>
          - Setting Up Employee Matches between Housecall Pro & Gusto <br />
          - Using the Housecall Pro & Gusto Integration <br />
          <a href="https://gusto.com/go/bd/housecallpro?utm_source=housecallpro&utm_campaign=announcement_in_app">
            {' '}
            Get Started{' '}
          </a>
        </p>
      </>
    ),
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    description: (
      <Grid container spacing={8}>
        <Grid item>
          <Typography align="left" variant="body1">
            <a href="https://gusto.com/product/pricing" target="_blank" rel="noreferrer">
              https://gusto.com/product/pricing
            </a>
          </Typography>
        </Grid>
        <Grid item>
          <Typography align="center" color="textSecondary">
            Starting at $40/month
          </Typography>
        </Grid>
      </Grid>
    ),
    hideToggle: true,
    appActionButton: <GustoButton />,
  },
  supportContacts: [
    { type: 'Email', contact: 'hcp@gusto.com' },
    { type: 'Phone', contact: '(800) 936-0383' },
  ],
};

export default GustoStrategy;
